module.exports = __webpack_public_path__ + "img/cms-list-default.7dcbc52f.svg";